import { baseApi as api } from './baseApi';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    getFirebaseTokenV1UserFirebaseTokenGet: build.query<
      GetFirebaseTokenV1UserFirebaseTokenGetApiResponse,
      GetFirebaseTokenV1UserFirebaseTokenGetApiArg
    >({
      query: () => ({ url: `/v1/user/firebase_token` }),
    }),
    createUserV1UserAddUserPost: build.mutation<
      CreateUserV1UserAddUserPostApiResponse,
      CreateUserV1UserAddUserPostApiArg
    >({
      query: queryArg => ({ url: `/v1/user/add_user`, method: 'POST', body: queryArg.newUserData }),
    }),
    listUsersV1UserAuth0OrgIdListGet: build.query<
      ListUsersV1UserAuth0OrgIdListGetApiResponse,
      ListUsersV1UserAuth0OrgIdListGetApiArg
    >({
      query: queryArg => ({ url: `/v1/user/${queryArg.auth0OrgId}/list` }),
    }),
    getUserIdV1UserGet: build.query<GetUserIdV1UserGetApiResponse, GetUserIdV1UserGetApiArg>({
      query: () => ({ url: `/v1/user/` }),
    }),
    updateUsersV1UserPut: build.mutation<UpdateUsersV1UserPutApiResponse, UpdateUsersV1UserPutApiArg>({
      query: queryArg => ({ url: `/v1/user/`, method: 'PUT', body: queryArg.userUpdateData }),
    }),
    listUserRolesV1UserAuth0OrgIdRolesGet: build.query<
      ListUserRolesV1UserAuth0OrgIdRolesGetApiResponse,
      ListUserRolesV1UserAuth0OrgIdRolesGetApiArg
    >({
      query: queryArg => ({ url: `/v1/user/${queryArg.auth0OrgId}/roles` }),
    }),
    getLocationsV1UserAuth0OrgIdLocationsGet: build.query<
      GetLocationsV1UserAuth0OrgIdLocationsGetApiResponse,
      GetLocationsV1UserAuth0OrgIdLocationsGetApiArg
    >({
      query: queryArg => ({ url: `/v1/user/${queryArg.auth0OrgId}/locations` }),
    }),
    getTenantsV1UserTenantsGet: build.query<GetTenantsV1UserTenantsGetApiResponse, GetTenantsV1UserTenantsGetApiArg>({
      query: () => ({ url: `/v1/user/tenants` }),
    }),
    loadSetToDraftV1SetsSetCodeGet: build.query<
      LoadSetToDraftV1SetsSetCodeGetApiResponse,
      LoadSetToDraftV1SetsSetCodeGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/set/${queryArg.code}` }),
    }),
    listDraftsV1SetsDraftListGet: build.query<
      ListDraftsV1SetsDraftListGetApiResponse,
      ListDraftsV1SetsDraftListGetApiArg
    >({
      query: () => ({ url: `/v1/sets/draft_list` }),
    }),
    getDraftV1SetsDraftIdGet: build.query<GetDraftV1SetsDraftIdGetApiResponse, GetDraftV1SetsDraftIdGetApiArg>({
      query: queryArg => ({ url: `/v1/sets/draft/${queryArg.id}` }),
    }),
    mergeDraftV1SetsDraftIdPut: build.mutation<MergeDraftV1SetsDraftIdPutApiResponse, MergeDraftV1SetsDraftIdPutApiArg>(
      {
        query: queryArg => ({
          url: `/v1/sets/draft/${queryArg.id}`,
          method: 'PUT',
          params: { dry_run: queryArg.dryRun },
        }),
      },
    ),
    saveDraftV1SetsDraftIdPost: build.mutation<SaveDraftV1SetsDraftIdPostApiResponse, SaveDraftV1SetsDraftIdPostApiArg>(
      {
        query: queryArg => ({ url: `/v1/sets/draft/${queryArg.id}`, method: 'POST', body: queryArg.body }),
      },
    ),
    deleteDraftV1SetsDraftIdDelete: build.mutation<
      DeleteDraftV1SetsDraftIdDeleteApiResponse,
      DeleteDraftV1SetsDraftIdDeleteApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/draft/${queryArg.id}`, method: 'DELETE' }),
    }),
    submitDraftV1SetsSubmitDraftSetIdStatusPost: build.mutation<
      SubmitDraftV1SetsSubmitDraftSetIdStatusPostApiResponse,
      SubmitDraftV1SetsSubmitDraftSetIdStatusPostApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/submit_draft/${queryArg.setId}/${queryArg.status}`, method: 'POST' }),
    }),
    listPendingDraftsV1SetsPendingDraftsStatusGet: build.query<
      ListPendingDraftsV1SetsPendingDraftsStatusGetApiResponse,
      ListPendingDraftsV1SetsPendingDraftsStatusGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/pending_drafts/${queryArg.status}` }),
    }),
    validateDraftV1SetsDraftValidateSetIdGet: build.query<
      ValidateDraftV1SetsDraftValidateSetIdGetApiResponse,
      ValidateDraftV1SetsDraftValidateSetIdGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/draft/validate/${queryArg.setId}` }),
    }),
    previewDraftV1SetsDraftPdfIdGet: build.query<
      PreviewDraftV1SetsDraftPdfIdGetApiResponse,
      PreviewDraftV1SetsDraftPdfIdGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/draft/pdf/${queryArg.id}` }),
    }),
    viewSetPdfV1SetsSetPdfIdGet: build.query<ViewSetPdfV1SetsSetPdfIdGetApiResponse, ViewSetPdfV1SetsSetPdfIdGetApiArg>(
      {
        query: queryArg => ({ url: `/v1/sets/set/pdf/${queryArg.id}` }),
      },
    ),
    getAssetV1SetsAssetIdFolderNameGet: build.query<
      GetAssetV1SetsAssetIdFolderNameGetApiResponse,
      GetAssetV1SetsAssetIdFolderNameGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/asset/${queryArg.id}/${queryArg.folder}/${queryArg.name}` }),
    }),
    putAssetV1SetsAssetIdFolderNamePost: build.mutation<
      PutAssetV1SetsAssetIdFolderNamePostApiResponse,
      PutAssetV1SetsAssetIdFolderNamePostApiArg
    >({
      query: queryArg => ({
        url: `/v1/sets/asset/${queryArg.id}/${queryArg.folder}/${queryArg.name}`,
        method: 'POST',
        body: queryArg.bodyPutAssetV1SetsAssetIdFolderNamePost,
      }),
    }),
    delAssetV1SetsAssetIdFolderNameDelete: build.mutation<
      DelAssetV1SetsAssetIdFolderNameDeleteApiResponse,
      DelAssetV1SetsAssetIdFolderNameDeleteApiArg
    >({
      query: queryArg => ({
        url: `/v1/sets/asset/${queryArg.id}/${queryArg.folder}/${queryArg.name}`,
        method: 'DELETE',
      }),
    }),
    getNewsV1SetsNewsNewsTypeGet: build.query<
      GetNewsV1SetsNewsNewsTypeGetApiResponse,
      GetNewsV1SetsNewsNewsTypeGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/news/${queryArg.newsType}` }),
    }),
    appendNewsV1SetsNewsUserIdHeadlinePut: build.mutation<
      AppendNewsV1SetsNewsUserIdHeadlinePutApiResponse,
      AppendNewsV1SetsNewsUserIdHeadlinePutApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/news/${queryArg.userId}/${queryArg.headline}`, method: 'PUT' }),
    }),
    getDiffV1SetsDraftDiffGet: build.query<GetDiffV1SetsDraftDiffGetApiResponse, GetDiffV1SetsDraftDiffGetApiArg>({
      query: queryArg => ({ url: `/v1/sets/draft/diff`, params: { modified_set: queryArg.modifiedSet } }),
    }),
    searchSetsAndPartsV1SetsSearchFilterGet: build.query<
      SearchSetsAndPartsV1SetsSearchFilterGetApiResponse,
      SearchSetsAndPartsV1SetsSearchFilterGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/search/${queryArg.filter}` }),
    }),
    getPartByIdV1SetsPartIdGet: build.query<GetPartByIdV1SetsPartIdGetApiResponse, GetPartByIdV1SetsPartIdGetApiArg>({
      query: queryArg => ({ url: `/v1/sets/part/${queryArg.id}` }),
    }),
    getImageForSetV1SetsSetImagesCodeGet: build.query<
      GetImageForSetV1SetsSetImagesCodeGetApiResponse,
      GetImageForSetV1SetsSetImagesCodeGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sets/set_images/${queryArg.code}` }),
    }),
    getArchivesV1ArchiveGet: build.query<GetArchivesV1ArchiveGetApiResponse, GetArchivesV1ArchiveGetApiArg>({
      query: () => ({ url: `/v1/archive/` }),
    }),
    showDashboardV1DashboardGet: build.query<ShowDashboardV1DashboardGetApiResponse, ShowDashboardV1DashboardGetApiArg>(
      {
        query: () => ({ url: `/v1/dashboard/` }),
      },
    ),
    updatePartImageV1DeviceUpdateImageIdPut: build.mutation<
      UpdatePartImageV1DeviceUpdateImageIdPutApiResponse,
      UpdatePartImageV1DeviceUpdateImageIdPutApiArg
    >({
      query: queryArg => ({ url: `/v1/device/update_image/${queryArg.id}`, method: 'PUT', body: queryArg.image }),
    }),
    getPartByIdV1DevicePartIdGet: build.query<
      GetPartByIdV1DevicePartIdGetApiResponse,
      GetPartByIdV1DevicePartIdGetApiArg
    >({
      query: queryArg => ({ url: `/v1/device/part/${queryArg.id}` }),
    }),
    mergePartV1DevicePartPut: build.mutation<MergePartV1DevicePartPutApiResponse, MergePartV1DevicePartPutApiArg>({
      query: queryArg => ({
        url: `/v1/device/part`,
        method: 'PUT',
        params: { part_id: queryArg.partId, dry_run: queryArg.dryRun },
      }),
    }),
    updatePartV1DevicePartPost: build.mutation<UpdatePartV1DevicePartPostApiResponse, UpdatePartV1DevicePartPostApiArg>(
      {
        query: queryArg => ({ url: `/v1/device/part`, method: 'POST', body: queryArg.part }),
      },
    ),
    deletePartV1DevicePartDelete: build.mutation<
      DeletePartV1DevicePartDeleteApiResponse,
      DeletePartV1DevicePartDeleteApiArg
    >({
      query: queryArg => ({ url: `/v1/device/part`, method: 'DELETE', params: { part_id: queryArg.partId } }),
    }),
    submitPartV1DevicePartDraftPut: build.mutation<
      SubmitPartV1DevicePartDraftPutApiResponse,
      SubmitPartV1DevicePartDraftPutApiArg
    >({
      query: queryArg => ({
        url: `/v1/device/part_draft`,
        method: 'PUT',
        params: { part_id: queryArg.partId, status: queryArg.status },
      }),
    }),
    listPartsForUserV1DevicePartListGet: build.query<
      ListPartsForUserV1DevicePartListGetApiResponse,
      ListPartsForUserV1DevicePartListGetApiArg
    >({
      query: () => ({ url: `/v1/device/part_list` }),
    }),
    listPartsPendingV1DevicePendingPartsGet: build.query<
      ListPartsPendingV1DevicePendingPartsGetApiResponse,
      ListPartsPendingV1DevicePendingPartsGetApiArg
    >({
      query: () => ({ url: `/v1/device/pending_parts` }),
    }),
    searchAuditLogsV1AuditSearchPost: build.mutation<
      SearchAuditLogsV1AuditSearchPostApiResponse,
      SearchAuditLogsV1AuditSearchPostApiArg
    >({
      query: queryArg => ({ url: `/v1/audit/search`, method: 'POST', body: queryArg.logSearchConditions }),
    }),
    searchAuditLogsByOperatorV1AuditSearchByOperatorPost: build.mutation<
      SearchAuditLogsByOperatorV1AuditSearchByOperatorPostApiResponse,
      SearchAuditLogsByOperatorV1AuditSearchByOperatorPostApiArg
    >({
      query: queryArg => ({
        url: `/v1/audit/search_by_operator`,
        method: 'POST',
        params: { operator_email: queryArg.operatorEmail, days: queryArg.days },
      }),
    }),
    searchAuditLogsByApiV1AuditSearchByApiPost: build.mutation<
      SearchAuditLogsByApiV1AuditSearchByApiPostApiResponse,
      SearchAuditLogsByApiV1AuditSearchByApiPostApiArg
    >({
      query: queryArg => ({
        url: `/v1/audit/search_by_api`,
        method: 'POST',
        params: { api_category: queryArg.apiCategory, days: queryArg.days },
      }),
    }),
    searchAuditLogsByEventTypeV1AuditSearchByEventTypePost: build.mutation<
      SearchAuditLogsByEventTypeV1AuditSearchByEventTypePostApiResponse,
      SearchAuditLogsByEventTypeV1AuditSearchByEventTypePostApiArg
    >({
      query: queryArg => ({
        url: `/v1/audit/search_by_event_type`,
        method: 'POST',
        params: { event_type: queryArg.eventType, days: queryArg.days },
      }),
    }),
    exportAuditLogsV1AuditExportPost: build.mutation<
      ExportAuditLogsV1AuditExportPostApiResponse,
      ExportAuditLogsV1AuditExportPostApiArg
    >({
      query: queryArg => ({ url: `/v1/audit/export`, method: 'POST', body: queryArg.logSearchConditions }),
    }),
    generateAuditReportV1AuditReportPost: build.mutation<
      GenerateAuditReportV1AuditReportPostApiResponse,
      GenerateAuditReportV1AuditReportPostApiArg
    >({
      query: queryArg => ({ url: `/v1/audit/report`, method: 'POST', body: queryArg.dbSearchConditions }),
    }),
    searchSetByCodeV1SatoSetsZzcodeFragmentGet: build.query<
      SearchSetByCodeV1SatoSetsZzcodeFragmentGetApiResponse,
      SearchSetByCodeV1SatoSetsZzcodeFragmentGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/sets/${queryArg.zzcodeFragment}/` }),
    }),
    getAllDraftSetsV1SatoSetsDraftGet: build.query<
      GetAllDraftSetsV1SatoSetsDraftGetApiResponse,
      GetAllDraftSetsV1SatoSetsDraftGetApiArg
    >({
      query: () => ({ url: `/v1/sato/sets_draft/` }),
    }),
    searchSetsByStatusV1SatoSetsDraftStatusGet: build.query<
      SearchSetsByStatusV1SatoSetsDraftStatusGetApiResponse,
      SearchSetsByStatusV1SatoSetsDraftStatusGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/sets_draft/${queryArg.status}/` }),
    }),
    updateVideoV1SatoVideoSetCodeTrayIdPut: build.mutation<
      UpdateVideoV1SatoVideoSetCodeTrayIdPutApiResponse,
      UpdateVideoV1SatoVideoSetCodeTrayIdPutApiArg
    >({
      query: queryArg => ({
        url: `/v1/sato/video/${queryArg.setCode}/${queryArg.trayId}/`,
        method: 'PUT',
        body: queryArg.videoBody,
      }),
    }),
    videoStreamingUrlV1SatoVideoSetCodeTrayIdVideoTypeVideoOrderExpireSecondsGet: build.query<
      VideoStreamingUrlV1SatoVideoSetCodeTrayIdVideoTypeVideoOrderExpireSecondsGetApiResponse,
      VideoStreamingUrlV1SatoVideoSetCodeTrayIdVideoTypeVideoOrderExpireSecondsGetApiArg
    >({
      query: queryArg => ({
        url: `/v1/sato/video/${queryArg.setCode}/${queryArg.trayId}/${queryArg.videoType}/${queryArg.videoOrder}/${queryArg.expireSeconds}/`,
      }),
    }),
    checkoutSetV1SatoSetZzcodePatch: build.mutation<
      CheckoutSetV1SatoSetZzcodePatchApiResponse,
      CheckoutSetV1SatoSetZzcodePatchApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/set/${queryArg.zzcode}/`, method: 'PATCH' }),
    }),
    updateDraftFromDbV1SatoSetsDraftZzcodePatch: build.mutation<
      UpdateDraftFromDbV1SatoSetsDraftZzcodePatchApiResponse,
      UpdateDraftFromDbV1SatoSetsDraftZzcodePatchApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/sets_draft/${queryArg.zzcode}/`, method: 'PATCH' }),
    }),
    readSetFromDbV1SatoDebugFolderZzcodeGet: build.query<
      ReadSetFromDbV1SatoDebugFolderZzcodeGetApiResponse,
      ReadSetFromDbV1SatoDebugFolderZzcodeGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/debug/${queryArg.folder}/${queryArg.zzcode}/` }),
    }),
    deleteSetFromDbV1SatoDebugFolderZzcodeDelete: build.mutation<
      DeleteSetFromDbV1SatoDebugFolderZzcodeDeleteApiResponse,
      DeleteSetFromDbV1SatoDebugFolderZzcodeDeleteApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/debug/${queryArg.folder}/${queryArg.zzcode}/`, method: 'DELETE' }),
    }),
    changeTrayStatusV1SatoTraySetCodeTrayIdPut: build.mutation<
      ChangeTrayStatusV1SatoTraySetCodeTrayIdPutApiResponse,
      ChangeTrayStatusV1SatoTraySetCodeTrayIdPutApiArg
    >({
      query: queryArg => ({
        url: `/v1/sato/tray/${queryArg.setCode}/${queryArg.trayId}/`,
        method: 'PUT',
        body: queryArg.statusBody,
      }),
    }),
    changeSetStatusV1SatoSetSetCodePut: build.mutation<
      ChangeSetStatusV1SatoSetSetCodePutApiResponse,
      ChangeSetStatusV1SatoSetSetCodePutApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/set/${queryArg.setCode}/`, method: 'PUT', body: queryArg.statusBody }),
    }),
    getSadlDraftStatusV1SatoSadlDraftStatusSetCodeGet: build.query<
      GetSadlDraftStatusV1SatoSadlDraftStatusSetCodeGetApiResponse,
      GetSadlDraftStatusV1SatoSadlDraftStatusSetCodeGetApiArg
    >({
      query: queryArg => ({ url: `/v1/sato/sadl_draft_status/${queryArg.setCode}` }),
    }),
    listFileUploadsV1OrdersReceivingFileUploadGet: build.query<
      ListFileUploadsV1OrdersReceivingFileUploadGetApiResponse,
      ListFileUploadsV1OrdersReceivingFileUploadGetApiArg
    >({
      query: () => ({ url: `/v1/orders/receiving/file-upload` }),
    }),
    receivingFileUploadV1OrdersReceivingFileUploadPost: build.mutation<
      ReceivingFileUploadV1OrdersReceivingFileUploadPostApiResponse,
      ReceivingFileUploadV1OrdersReceivingFileUploadPostApiArg
    >({
      query: queryArg => ({
        url: `/v1/orders/receiving/file-upload`,
        method: 'POST',
        body: queryArg.bodyReceivingFileUploadV1OrdersReceivingFileUploadPost,
      }),
    }),
    getFileUploadV1OrdersReceivingFileUploadUploadIdGet: build.query<
      GetFileUploadV1OrdersReceivingFileUploadUploadIdGetApiResponse,
      GetFileUploadV1OrdersReceivingFileUploadUploadIdGetApiArg
    >({
      query: queryArg => ({ url: `/v1/orders/receiving/file-upload/${queryArg.uploadId}` }),
    }),
    finaliseFileUploadV1OrdersReceivingFileUploadUploadIdPut: build.mutation<
      FinaliseFileUploadV1OrdersReceivingFileUploadUploadIdPutApiResponse,
      FinaliseFileUploadV1OrdersReceivingFileUploadUploadIdPutApiArg
    >({
      query: queryArg => ({
        url: `/v1/orders/receiving/file-upload/${queryArg.uploadId}`,
        method: 'PUT',
        body: queryArg.putFileUploadBody,
      }),
    }),
    deleteFileUploadV1OrdersReceivingFileUploadUploadIdDelete: build.mutation<
      DeleteFileUploadV1OrdersReceivingFileUploadUploadIdDeleteApiResponse,
      DeleteFileUploadV1OrdersReceivingFileUploadUploadIdDeleteApiArg
    >({
      query: queryArg => ({ url: `/v1/orders/receiving/file-upload/${queryArg.uploadId}`, method: 'DELETE' }),
    }),
    listReceivingOrdersV1OrdersReceivingListGet: build.query<
      ListReceivingOrdersV1OrdersReceivingListGetApiResponse,
      ListReceivingOrdersV1OrdersReceivingListGetApiArg
    >({
      query: queryArg => ({
        url: `/v1/orders/receiving/list`,
        params: {
          date_to: queryArg.dateTo,
          date_from: queryArg.dateFrom,
          status: queryArg.status,
          last_id: queryArg.lastId,
        },
      }),
    }),
    getSetV2SetsCodeGet: build.query<GetSetV2SetsCodeGetApiResponse, GetSetV2SetsCodeGetApiArg>({
      query: queryArg => ({ url: `/v2/sets/${queryArg.code}` }),
    }),
    putAssetV2SetsAssetSetIdPost: build.mutation<
      PutAssetV2SetsAssetSetIdPostApiResponse,
      PutAssetV2SetsAssetSetIdPostApiArg
    >({
      query: queryArg => ({
        url: `/v2/sets/asset/${queryArg.setId}/`,
        method: 'POST',
        body: queryArg.bodyPutAssetV2SetsAssetSetIdPost,
        params: { asset_type: queryArg.assetType, region: queryArg.region },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as apiGenerated };
export type GetFirebaseTokenV1UserFirebaseTokenGetApiResponse = /** status 200 Successful Response */ { token: string };
export type GetFirebaseTokenV1UserFirebaseTokenGetApiArg = void;
export type CreateUserV1UserAddUserPostApiResponse = /** status 200 Successful Response */ any;
export type CreateUserV1UserAddUserPostApiArg = {
  newUserData: NewUserData;
};
export type ListUsersV1UserAuth0OrgIdListGetApiResponse = /** status 200 Successful Response */ any;
export type ListUsersV1UserAuth0OrgIdListGetApiArg = {
  auth0OrgId: string;
};
export type GetUserIdV1UserGetApiResponse = /** status 200 Successful Response */ {
  user_id: string;
  region: Region;
  location: string;
};
export type GetUserIdV1UserGetApiArg = void;
export type UpdateUsersV1UserPutApiResponse = /** status 200 Successful Response */ any;
export type UpdateUsersV1UserPutApiArg = {
  userUpdateData: UserUpdateData;
};
export type ListUserRolesV1UserAuth0OrgIdRolesGetApiResponse = /** status 200 Successful Response */ any;
export type ListUserRolesV1UserAuth0OrgIdRolesGetApiArg = {
  auth0OrgId: string;
};
export type GetLocationsV1UserAuth0OrgIdLocationsGetApiResponse = /** status 200 Successful Response */ any;
export type GetLocationsV1UserAuth0OrgIdLocationsGetApiArg = {
  auth0OrgId: string;
};
export type GetTenantsV1UserTenantsGetApiResponse = /** status 200 Successful Response */ any;
export type GetTenantsV1UserTenantsGetApiArg = void;
export type LoadSetToDraftV1SetsSetCodeGetApiResponse = /** status 200 Successful Response */ any;
export type LoadSetToDraftV1SetsSetCodeGetApiArg = {
  code: string;
};
export type ListDraftsV1SetsDraftListGetApiResponse = /** status 200 Successful Response */ any;
export type ListDraftsV1SetsDraftListGetApiArg = void;
export type GetDraftV1SetsDraftIdGetApiResponse = /** status 200 Successful Response */ any;
export type GetDraftV1SetsDraftIdGetApiArg = {
  id: string;
};
export type MergeDraftV1SetsDraftIdPutApiResponse = /** status 200 Successful Response */ any;
export type MergeDraftV1SetsDraftIdPutApiArg = {
  id: string;
  dryRun?: boolean;
};
export type SaveDraftV1SetsDraftIdPostApiResponse = /** status 200 Successful Response */ any;
export type SaveDraftV1SetsDraftIdPostApiArg = {
  id: string;
  body: object;
};
export type DeleteDraftV1SetsDraftIdDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeleteDraftV1SetsDraftIdDeleteApiArg = {
  id: string;
};
export type SubmitDraftV1SetsSubmitDraftSetIdStatusPostApiResponse = /** status 200 Successful Response */ any;
export type SubmitDraftV1SetsSubmitDraftSetIdStatusPostApiArg = {
  setId: string;
  status: SetStatusSubmitDraft;
};
export type ListPendingDraftsV1SetsPendingDraftsStatusGetApiResponse = /** status 200 Successful Response */ any;
export type ListPendingDraftsV1SetsPendingDraftsStatusGetApiArg = {
  status: SetStatusPendingDrafts;
};
export type ValidateDraftV1SetsDraftValidateSetIdGetApiResponse = /** status 200 Successful Response */ any;
export type ValidateDraftV1SetsDraftValidateSetIdGetApiArg = {
  setId: string;
};
export type PreviewDraftV1SetsDraftPdfIdGetApiResponse = /** status 200 Successful Response */ any;
export type PreviewDraftV1SetsDraftPdfIdGetApiArg = {
  id: string;
};
export type ViewSetPdfV1SetsSetPdfIdGetApiResponse = /** status 200 Successful Response */ any;
export type ViewSetPdfV1SetsSetPdfIdGetApiArg = {
  id: string;
};
export type GetAssetV1SetsAssetIdFolderNameGetApiResponse = /** status 200 Successful Response */ any;
export type GetAssetV1SetsAssetIdFolderNameGetApiArg = {
  id: string;
  folder: string;
  name: string;
};
export type PutAssetV1SetsAssetIdFolderNamePostApiResponse = /** status 200 Successful Response */ any;
export type PutAssetV1SetsAssetIdFolderNamePostApiArg = {
  id: string;
  folder: string;
  name: string;
  bodyPutAssetV1SetsAssetIdFolderNamePost: BodyPutAssetV1SetsAssetIdFolderNamePost;
};
export type DelAssetV1SetsAssetIdFolderNameDeleteApiResponse = /** status 200 Successful Response */ any;
export type DelAssetV1SetsAssetIdFolderNameDeleteApiArg = {
  id: string;
  folder: string;
  name: string;
};
export type GetNewsV1SetsNewsNewsTypeGetApiResponse = /** status 200 Successful Response */ any;
export type GetNewsV1SetsNewsNewsTypeGetApiArg = {
  newsType: string;
};
export type AppendNewsV1SetsNewsUserIdHeadlinePutApiResponse = /** status 200 Successful Response */ any;
export type AppendNewsV1SetsNewsUserIdHeadlinePutApiArg = {
  headline: string;
  userId: string;
};
export type GetDiffV1SetsDraftDiffGetApiResponse = /** status 200 Successful Response */ any;
export type GetDiffV1SetsDraftDiffGetApiArg = {
  modifiedSet: string;
};
export type SearchSetsAndPartsV1SetsSearchFilterGetApiResponse = /** status 200 Successful Response */ any;
export type SearchSetsAndPartsV1SetsSearchFilterGetApiArg = {
  filter: string;
};
export type GetPartByIdV1SetsPartIdGetApiResponse = /** status 200 Successful Response */ any;
export type GetPartByIdV1SetsPartIdGetApiArg = {
  id: string;
};
export type GetImageForSetV1SetsSetImagesCodeGetApiResponse = /** status 200 Successful Response */ any;
export type GetImageForSetV1SetsSetImagesCodeGetApiArg = {
  code: string;
};
export type GetArchivesV1ArchiveGetApiResponse = /** status 200 Successful Response */ any;
export type GetArchivesV1ArchiveGetApiArg = void;
export type ShowDashboardV1DashboardGetApiResponse = /** status 200 Successful Response */ any;
export type ShowDashboardV1DashboardGetApiArg = void;
export type UpdatePartImageV1DeviceUpdateImageIdPutApiResponse = /** status 200 Successful Response */ any;
export type UpdatePartImageV1DeviceUpdateImageIdPutApiArg = {
  id: string;
  image: Image;
};
export type GetPartByIdV1DevicePartIdGetApiResponse = /** status 200 Successful Response */ any;
export type GetPartByIdV1DevicePartIdGetApiArg = {
  id: string;
};
export type MergePartV1DevicePartPutApiResponse = /** status 200 Successful Response */ any;
export type MergePartV1DevicePartPutApiArg = {
  partId: string;
  dryRun?: boolean;
};
export type UpdatePartV1DevicePartPostApiResponse = /** status 200 Successful Response */ any;
export type UpdatePartV1DevicePartPostApiArg = {
  part: Part;
};
export type DeletePartV1DevicePartDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeletePartV1DevicePartDeleteApiArg = {
  partId: string;
};
export type SubmitPartV1DevicePartDraftPutApiResponse = /** status 200 Successful Response */ any;
export type SubmitPartV1DevicePartDraftPutApiArg = {
  partId: string;
  status: PartStatus;
};
export type ListPartsForUserV1DevicePartListGetApiResponse = /** status 200 Successful Response */ any;
export type ListPartsForUserV1DevicePartListGetApiArg = void;
export type ListPartsPendingV1DevicePendingPartsGetApiResponse = /** status 200 Successful Response */ any;
export type ListPartsPendingV1DevicePendingPartsGetApiArg = void;
export type SearchAuditLogsV1AuditSearchPostApiResponse = /** status 200 Successful Response */ any;
export type SearchAuditLogsV1AuditSearchPostApiArg = {
  logSearchConditions: LogSearchConditions;
};
export type SearchAuditLogsByOperatorV1AuditSearchByOperatorPostApiResponse = /** status 200 Successful Response */ any;
export type SearchAuditLogsByOperatorV1AuditSearchByOperatorPostApiArg = {
  operatorEmail: string;
  days?: number;
};
export type SearchAuditLogsByApiV1AuditSearchByApiPostApiResponse = /** status 200 Successful Response */ any;
export type SearchAuditLogsByApiV1AuditSearchByApiPostApiArg = {
  apiCategory: string;
  days?: number;
};
export type SearchAuditLogsByEventTypeV1AuditSearchByEventTypePostApiResponse =
  /** status 200 Successful Response */ any;
export type SearchAuditLogsByEventTypeV1AuditSearchByEventTypePostApiArg = {
  eventType: string;
  days?: number;
};
export type ExportAuditLogsV1AuditExportPostApiResponse = /** status 200 Successful Response */ any;
export type ExportAuditLogsV1AuditExportPostApiArg = {
  logSearchConditions: LogSearchConditions;
};
export type GenerateAuditReportV1AuditReportPostApiResponse = /** status 200 Successful Response */ any;
export type GenerateAuditReportV1AuditReportPostApiArg = {
  dbSearchConditions: DbSearchConditions;
};
export type SearchSetByCodeV1SatoSetsZzcodeFragmentGetApiResponse = /** status 200 Successful Response */ any;
export type SearchSetByCodeV1SatoSetsZzcodeFragmentGetApiArg = {
  zzcodeFragment: string;
};
export type GetAllDraftSetsV1SatoSetsDraftGetApiResponse = /** status 200 Successful Response */ SatoDraftSet[];
export type GetAllDraftSetsV1SatoSetsDraftGetApiArg = void;
export type SearchSetsByStatusV1SatoSetsDraftStatusGetApiResponse = /** status 200 Successful Response */ any;
export type SearchSetsByStatusV1SatoSetsDraftStatusGetApiArg = {
  status: SatoStatus;
};
export type UpdateVideoV1SatoVideoSetCodeTrayIdPutApiResponse = /** status 200 Successful Response */ any;
export type UpdateVideoV1SatoVideoSetCodeTrayIdPutApiArg = {
  setCode: string;
  trayId: string;
  videoBody: VideoBody;
};
export type VideoStreamingUrlV1SatoVideoSetCodeTrayIdVideoTypeVideoOrderExpireSecondsGetApiResponse =
  /** status 200 Successful Response */ any;
export type VideoStreamingUrlV1SatoVideoSetCodeTrayIdVideoTypeVideoOrderExpireSecondsGetApiArg = {
  setCode: string;
  trayId: string;
  videoType: SatoVideoTypes;
  videoOrder: number;
  expireSeconds: number;
};
export type CheckoutSetV1SatoSetZzcodePatchApiResponse = /** status 200 Successful Response */ any;
export type CheckoutSetV1SatoSetZzcodePatchApiArg = {
  zzcode: string;
};
export type UpdateDraftFromDbV1SatoSetsDraftZzcodePatchApiResponse = /** status 200 Successful Response */ any;
export type UpdateDraftFromDbV1SatoSetsDraftZzcodePatchApiArg = {
  zzcode: string;
};
export type ReadSetFromDbV1SatoDebugFolderZzcodeGetApiResponse = /** status 200 Successful Response */ any;
export type ReadSetFromDbV1SatoDebugFolderZzcodeGetApiArg = {
  folder: string;
  zzcode: string;
};
export type DeleteSetFromDbV1SatoDebugFolderZzcodeDeleteApiResponse = /** status 200 Successful Response */ any;
export type DeleteSetFromDbV1SatoDebugFolderZzcodeDeleteApiArg = {
  folder: string;
  zzcode: string;
};
export type ChangeTrayStatusV1SatoTraySetCodeTrayIdPutApiResponse = /** status 200 Successful Response */ any;
export type ChangeTrayStatusV1SatoTraySetCodeTrayIdPutApiArg = {
  setCode: string;
  trayId: string;
  statusBody: StatusBody;
};
export type ChangeSetStatusV1SatoSetSetCodePutApiResponse = /** status 200 Successful Response */ any;
export type ChangeSetStatusV1SatoSetSetCodePutApiArg = {
  setCode: string;
  statusBody: StatusBody;
};
export type GetSadlDraftStatusV1SatoSadlDraftStatusSetCodeGetApiResponse = /** status 200 Successful Response */ any;
export type GetSadlDraftStatusV1SatoSadlDraftStatusSetCodeGetApiArg = {
  setCode: string;
};
export type ListFileUploadsV1OrdersReceivingFileUploadGetApiResponse = /** status 200 Successful Response */ any;
export type ListFileUploadsV1OrdersReceivingFileUploadGetApiArg = void;
export type ReceivingFileUploadV1OrdersReceivingFileUploadPostApiResponse = /** status 200 Successful Response */ any;
export type ReceivingFileUploadV1OrdersReceivingFileUploadPostApiArg = {
  bodyReceivingFileUploadV1OrdersReceivingFileUploadPost: BodyReceivingFileUploadV1OrdersReceivingFileUploadPost;
};
export type GetFileUploadV1OrdersReceivingFileUploadUploadIdGetApiResponse = /** status 200 Successful Response */ any;
export type GetFileUploadV1OrdersReceivingFileUploadUploadIdGetApiArg = {
  uploadId: string;
};
export type FinaliseFileUploadV1OrdersReceivingFileUploadUploadIdPutApiResponse =
  /** status 200 Successful Response */ any;
export type FinaliseFileUploadV1OrdersReceivingFileUploadUploadIdPutApiArg = {
  uploadId: string;
  putFileUploadBody: PutFileUploadBody;
};
export type DeleteFileUploadV1OrdersReceivingFileUploadUploadIdDeleteApiResponse =
  /** status 200 Successful Response */ any;
export type DeleteFileUploadV1OrdersReceivingFileUploadUploadIdDeleteApiArg = {
  uploadId: string;
};
export type ListReceivingOrdersV1OrdersReceivingListGetApiResponse = /** status 200 Successful Response */ any;
export type ListReceivingOrdersV1OrdersReceivingListGetApiArg = {
  dateTo?: string;
  dateFrom?: string;
  status?: string;
  lastId?: string;
};
export type GetSetV2SetsCodeGetApiResponse = /** status 200 Successful Response */ SadlSet;
export type GetSetV2SetsCodeGetApiArg = {
  code: string;
};
export type PutAssetV2SetsAssetSetIdPostApiResponse = /** status 200 Successful Response */ UploadAssetResponse;
export type PutAssetV2SetsAssetSetIdPostApiArg = {
  setId: string;
  assetType: AssetType;
  region: Region;
  bodyPutAssetV2SetsAssetSetIdPost: BodyPutAssetV2SetsAssetSetIdPost;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type NewUserData = {
  email: string;
};
export type User = {
  user_id: string;
  email: string;
  auth0_role_id?: string;
  auth0_id: string;
  auth0_org_id?: string;
  tenant_id?: string;
  location_id?: string;
  archived: boolean;
};
export type UserUpdateData = {
  users: User[];
};
export type SetStatusSubmitDraft = 'REVIEW' | 'PENDING' | 'DRAFT' | 'MODIFIED';
export type SetStatusPendingDrafts = 'REVIEW' | 'PENDING';
export type BodyPutAssetV1SetsAssetIdFolderNamePost = {
  image: Blob;
};
export type Image = {
  url: string;
};
export type Part = {
  id: string;
  disassembly_info?: string;
  cannulated?: boolean;
  comments: string[];
  user: string;
  description: string;
  num_parts: number;
  status: string;
  image?: string;
  inspection_text_description?: string;
  test_metadata?: object;
  language_metadata?: object;
  prone_to_debris?: boolean;
};
export type PartStatus = 'part.draft' | 'part.pending';
export type LogSearchConditions = {
  start_time: string;
  end_time: string;
  payload_key_match: object;
};
export type DbSearchConditions = {
  start_time: string;
  end_time: string;
  user?: string;
};
export type SatoStatus =
  | 'sato.draft'
  | 'sato.pending'
  | 'sato.archived'
  | 'sato.rejected'
  | 'sato.approved'
  | 'sato.not_found';
export type SatoVideoTypes =
  | 'empty-tray'
  | 'in-tray-complete'
  | 'in-tray-incomplete'
  | 'outside-tray'
  | 'in-tray-shuffled'
  | 'additional';
export type SatoDraftVideo = {
  status: SatoStatus;
  url: string;
  type: SatoVideoTypes;
  order: number;
  crop_start?: number;
  crop_end?: number;
  converted_url?: string;
};
export type SatoDraftTray = {
  tray_description: string;
  comments: string[];
  tray_id: number;
  videos: SatoDraftVideo[];
  tray_image?: string;
  status: SatoStatus;
  tray_ref: string;
};
export type SatoDraftSet = {
  comments: string[];
  status: SatoStatus;
  trays: SatoDraftTray[];
  revision: string;
  code: string;
  group_desc: string;
  region: string;
  submitted_by?: string;
  submission_date?: string;
};
export type VideoBody = {
  status?: SatoStatus;
  comment?: string;
  type: SatoVideoTypes;
  order: number;
  crop_start?: number;
  crop_end?: number;
  url?: string;
};
export type StatusBody = {
  status: SatoStatus;
  comment?: string;
};
export type BodyReceivingFileUploadV1OrdersReceivingFileUploadPost = {
  file: Blob;
};
export type DuplicateOrderResponse = {
  gs_one_barcode: string;
  ignore: boolean;
};
export type PutFileUploadBody = {
  duplicates?: DuplicateOrderResponse[];
  merge: boolean;
};
export type TrayLanguageMetadata = {
  manual_english?: string;
  manual_japanese?: string;
  description_english?: string;
  description_japanese?: string;
  additional_text_japanese?: string;
};
export type TestMetadata = {
  additional_inspection_english?: string;
  additional_inspection_japanese?: string;
  torque_test?: boolean;
  functional_test?: boolean;
  debris_test?: boolean;
  prone_to_debris?: boolean;
};
export type LanguageMetadata = {
  manual_english?: string;
  manual_japanese?: string;
  description_english?: string;
  description_japanese?: string;
};
export type SadlPart = {
  ref: string;
  code: string;
  description?: string;
  part_image_file?: string;
  num_parts: number;
  cannulated?: boolean;
  debris_prone?: boolean;
  qty: number;
  requires_inspection?: boolean;
  inspection_text?: string;
  test_metadata?: TestMetadata;
  part_test_metadata?: TestMetadata;
  additional_info?: any;
  part_diagram?: string;
  disassembly_info?: string;
  language_metadata?: LanguageMetadata;
};
export type SadlTray = {
  name: string;
  reference: string;
  image_file?: string;
  original_image_file?: string;
  non_standard?: boolean;
  general_test?: boolean;
  additional_inspection_requirements?: string;
  model_config?: string;
  reference_tags_metadata?: string;
  language_metadata?: TrayLanguageMetadata;
  parts: {
    [key: string]: SadlPart;
  };
};
export type SetManuals = {
  manual_japanese?: string;
  manual_english?: string;
};
export type SadlSet = {
  region: string;
  code: string;
  jme_group: string;
  revision: string;
  savi_version: number;
  trays: {
    [key: string]: SadlTray;
  };
  set_manuals: SetManuals;
};
export type AssetType = 'set_manual';
export type Language = 'english' | 'japanese';
export type UploadAssetResponse = {
  asset_type: AssetType;
  language: Language;
  gs_uri: string;
};
export type Region = 'AUS' | 'JPN';
export type BodyPutAssetV2SetsAssetSetIdPost = {
  file: Blob;
};
